export interface DscsaFaqItem {
  q: string;
  a: string;
}

/**
 * Editorial dates for the DSCSA hub and guide family. Update dateModified only
 * when visitor-visible DSCSA editorial content changes.
 */
export const DSCSA_DATE_PUBLISHED = "2023-11-27";
export const DSCSA_DATE_MODIFIED = "2026-08-07";

export const DSCSA_HUB_FAQ: DscsaFaqItem[] = [
  {
    q: "What does DSCSA require for pharmacies?",
    a: "DSCSA requires pharmacies to accept only serialized prescription drug product from authorized trading partners, retain T2 transaction records (TI + TS) for 6 years, be able to quarantine and investigate suspect product, and notify the FDA within 24 hours of identifying illegitimate product. Dispensers with 26 or more full-time employees became fully subject to these requirements on November 27, 2025. Small dispensers with 25 or fewer full-time pharmacy employees received a one-year extension and must comply by November 27, 2027.",
  },
  {
    q: "When is the DSCSA deadline for small pharmacies?",
    a: "The current small-dispenser date for EPCIS interoperability is November 27, 2027 for pharmacies with 25 or fewer full-time pharmacy employees. The exemption is automatic; no FDA filing is required. Confirm current dates and requirements with FDA guidance.",
  },
  {
    q: "What are the penalties for DSCSA violations?",
    a: "Civil penalties for DSCSA violations can reach $250,000 for a first offense and $1,000,000 for repeated violations. Serious violations involving controlled substances can result in criminal prosecution. State boards of pharmacy may also take separate licensing action.",
  },
];

export function buildDscsaFaqJsonLd(items: DscsaFaqItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };
}